import {Component, inject} from '@angular/core';
import {ChooseYourGameComponent} from "../../../components/choose-your-game/choose-your-game.component";
import {ContainerComponent} from "@coreui/angular";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {DrawWinnerPageComponent} from "../game-admin-draw-winner/draw-winner-page.component";
import {GameService} from "../../../services/game.service";
import {GameInstanceService} from "../../../services/game-instance.service";
import {ActiveUserService} from "../../../services/active-user.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";

@Component({
  selector: 'app-cross-game-admin-draw-winner',
  standalone: true,
  imports: [
    ChooseYourGameComponent,
    ContainerComponent,
    DrawWinnerPageComponent
  ],
  templateUrl: './cross-game-admin-draw-winner.component.html',
  styleUrl: './cross-game-admin-draw-winner.component.css'
})
export class CrossGameAdminDrawWinnerComponent {

  private gameService: GameService = inject(GameService);
  private gameInstanceService: GameInstanceService = inject(GameInstanceService);
  private activeUserService: ActiveUserService = inject(ActiveUserService);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);
  chosenGame: IGameQueryResult | null = null;

  onGameChange(chosenGame: IGameQueryResult) {
    this.gameInstanceService.activeGameInstanceByGame(chosenGame.Id, this.activeUserService.activeUser().Id).subscribe({
      next: (res) => {
        this.gameService.updateActiveGame(chosenGame);
        this.chosenGame = chosenGame;
      },
      error: (err) => {
        this.errorHandlingService.displayPageLevelErrorMessage("Failed to get the active game instance for the chosen game");
      }
    });
  }
}
